"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.error = void 0;
exports.error = {
    path: "M9.99999 1.66675C5.39999 1.66675 1.66666 5.40008 1.66666 10.0001C1.66666 14.6001 5.39999 18.3334 9.99999 18.3334C14.6 18.3334 18.3333 14.6001 18.3333 10.0001C18.3333 5.40008 14.6 1.66675 9.99999 1.66675ZM9.16666 14.1667V12.5001H10.8333V14.1667H9.16666ZM9.16666 5.83341V10.8334H10.8333V5.83341H9.16666Z",
    originalWidth: 20,
    originalHeight: 20,
    basicColor: "tableGray1",
    activeColor: "tableBlack2",
};
